import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const OportunidadSection = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 4,
        px: 3,
        borderRadius: 2,
        bgcolor: theme.palette.alternate.main,
        borderLeft: 4,
        borderColor: theme.palette.primary.main,
      }}
    >
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 700 }}
        variant="overline"
        color="primary"
        display="block"
        gutterBottom
      >
        1. Estrategia central
      </Typography>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Atracción orgánica
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        El enfoque de la campaña se aleja de la publicidad intrusiva tradicional para centrarse en la{' '}
        <strong>atracción orgánica</strong> mediante contenido de alto valor. Nos posicionamos como el aliado
        estratégico que resuelve los problemas cotidianos de los usuarios con sus dispositivos móviles y
        corporativos, conectando las soluciones de <strong>Canguro</strong> con las audiencias clave de{' '}
        <strong>TNO Network</strong>.
      </Typography>
    </Box>
  );
};

export default OportunidadSection;
